export const fetchRequestBuilder =
    ({
        apiHost,
        backendFlags,
        apiRequestsRecords,
        defaultHeaders,
    }: {
        apiHost: string
        backendFlags?: string
        apiRequestsRecords?: string[]
        defaultHeaders?: HeadersInit
    }) =>
    async <T>(url: string, config: RequestInit = {}) => {
        if (typeof apiHost === 'undefined') {
            throw new Error('No apiHost was defined for requests')
        }

        const [baseUrl, queryString] = url.split('?')
        const params = new URLSearchParams(queryString)

        if (backendFlags) {
            params.set('flags', backendFlags)
        }

        apiRequestsRecords?.push(`${baseUrl}?${params}`)

        const headers = new Headers({ 'content-type': 'application/json' })
        new Headers(defaultHeaders).forEach((value, key) => headers.set(key, value))
        new Headers(config.headers).forEach((value, key) => headers.set(key, value))

        const resp = await fetch(`${apiHost}${baseUrl}?${params}`, {
            ...config,
            headers,
        })
        const bodyText = await resp.text()

        try {
            const isJson = resp.headers.get('content-type')?.includes('application/json')
            const body = isJson ? JSON.parse(bodyText || 'null') : bodyText
            if (resp.ok) {
                return {
                    originalResponse: resp,
                    data: body as T,
                    errors: [],
                    bodyText,
                }
            }
            return {
                originalResponse: resp,
                data: null,
                errors: isJson ? body?.errors || (body?.message ? [body.message] : []) : [bodyText],
                bodyText,
            }
        } catch (error) {
            const message = (error as Error).toString()
            return {
                originalResponse: resp,
                data: null,
                errors: [message],
                bodyText,
            }
        }
    }
